import { useEffect, useState } from "react"
import mainAxios from "../../services/mainAxios"

export const useGetFinantialInstitutions= ()=>{
  const [loading,setLoading] = useState(true)
  const [data,setData] = useState([])

  const getData =async ()=>{
    setLoading(true)
    return mainAxios
    .get("/api/financialInstitutions")
    .then( res=>{
      setLoading(false)
      if(res.status==200){
        setData(res?.data ?? []);
      }
    })
    .catch(err=>{
      setLoading(false)
      return null
    })
  }

  useEffect(()=>{
      getData()
  },[])

  return {getData,loading,setLoading,data,setData}
}
